import BusinessBarChartContainer from '../../modules/Businesses/containers/BusinessBarChartContainer';
import { AppPaths } from '../../helpers/globals/Constans.ts';

// Sync route definition
export default {
  path: `${AppPaths.HOME}*${AppPaths.BUSINESSES}`,
  component: BusinessBarChartContainer,
};
